// src/components/Fuß/Datenschutz.js
import React from 'react';
import './Datenschutz.css';

function Datenschutz() {
  return (
    <div className="datenschutz-container">
      {/* Kopfbereich */}
      <h1 className="datenschutz-title">Datenschutzerklärung</h1>
      <h2 className="datenschutz-subtitle">der prosperly GmbH</h2>
      <h3>August 2024</h3>

      {/* 1. Datenschutz auf einen Blick */}
      <div className="datenschutz-section">
        <h1>1. Datenschutz auf einen Blick</h1>

        <h2>Allgemeine Hinweise</h2>
        <p>
          Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren
          personenbezogenen Daten passiert, wenn Sie diese Website besuchen.
          Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert
          werden können. Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
          unserer unter diesem Text aufgeführten Datenschutzerklärung.
        </p>

        <h2>Datenerfassung auf dieser Website</h2>
        <p>
          <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong>
          <br />
          Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
          Dessen Kontaktdaten können Sie dem Impressum der Website entnehmen.
        </p>

        <h2>Wie erfassen wir Ihre Daten?</h2>
        <p>
          Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei
          kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
          Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der
          Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten
          (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die
          Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
        </p>

        <h2>Wofür nutzen wir Ihre Daten?</h2>
        <p>
          Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website
          zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens
          verwendet werden.
        </p>
        <p>
          Ferner werden die eingegebenen Daten für die Bearbeitung von Kundenanfragen sowie
          zur Erbringung der bezahlten Hausverwaltungsdienstleistungen genutzt. Die
          Weitergabe für die kommerzielle Nutzung Dritter ist hierbei ausgeschlossen. Für
          Ausnahmen wird die Gesellschaft sich separate Einwilligungen einholen.
        </p>

        <h2>Welche Rechte haben Sie bezüglich Ihrer Daten?</h2>
        <p>
          Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und
          Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem
          ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine
          Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung
          jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter
          bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen
          Daten zu verlangen. Des Weiteren steht Ihnen ein Beschwerderecht bei der
          zuständigen Aufsichtsbehörde zu.
        </p>
        <p>
          Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an
          uns wenden.
        </p>

        <h2>Analyse-Tools und Tools von Drittanbietern</h2>
        <p>
          Beim Besuch dieser Website kann Ihr Surf-Verhalten statistisch ausgewertet werden.
          Das geschieht vor allem mit sogenannten Analyseprogrammen. Detaillierte
          Informationen zu diesen Analyseprogrammen finden Sie in der folgenden
          Datenschutzerklärung.
        </p>
      </div>

      {/* 2. Hosting */}
      <div className="datenschutz-section">
        <h1>2. Hosting</h1>
        <h2>Externes Hosting</h2>
        <p>
          Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser
          Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei
          kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und
          Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und
          sonstige Daten, die über eine Website generiert werden, handeln.
        </p>
        <p>
          Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren
          potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse
          einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots
          durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine
          entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
          ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1
          TDDDG, soweit die Einwilligung die Speicherung von Cookies oder den Zugriff auf
          Informationen im Endgerät des Nutzers (z. B. Device-Fingerprinting) im Sinne des
          TDDDG umfasst. Die Einwilligung ist jederzeit widerrufbar.
        </p>
        <p>
          Unser Hoster wird Ihre Daten nur insoweit verarbeiten, wie dies zur Erfüllung
          seiner Leistungspflichten erforderlich ist und unsere Weisungen in Bezug auf
          diese Daten befolgen.
        </p>
        <p>
          Wir setzen folgenden Hoster ein:
          <br />
          <b>Vercel Inc. 340 S Lemon Ave</b>
          <br />
          <b>#4133 Walnut</b>
          <br />
          <b>CA 91789 Vereinigte Staaten</b>
          <br />
          <b>Vereinigte Staaten</b>
        </p>
      </div>

      {/* 3. Allgemeine Hinweise und Pflichtinformationen */}
      <div className="datenschutz-section">
        <h1>3. Allgemeine Hinweise und Pflichtinformationen</h1>
        <h2>Datenschutz</h2>
        <p>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr
          ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend
          den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung. Wenn
          Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben.
          Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden
          können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben
          und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das
          geschieht. Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B.
          bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein
          lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>

        <h2>Hinweis zur verantwortlichen Stelle</h2>
        <p>
          Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          <br />
          <b>prosperly GmbH</b>
          <br />
          <b>Varziner Str. 16</b>
          <br />
          <b>12161 Berlin</b>
          <br />
          <b>
            Telefon:{' '}
            <a href="tel:+4915141333478">+49 (0) 151 41333478</a>
          </b>
          <br />
          <b>
            E-mail:{' '}
            <a href="mailto:info@service.prosperly.de">info@service.prosperly.de</a>
          </b>
        </p>
        <p>
          Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder
          gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von
          personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
        </p>

        <h2>Speicherdauer</h2>
        <p>
          Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer
          genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für
          die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend
          machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten
          gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung
          Ihrer personenbezogenen Daten haben (z. B. steuer- oder handelsrechtliche
          Aufbewahrungsfristen); im letztgenannten Fall erfolgt die Löschung nach Fortfall
          dieser Gründe.
        </p>

        <h2>
          Allgemeine Hinweise zu den Rechtsgrundlagen der Datenverarbeitung auf dieser
          Website
        </h2>
        <p>
          Sofern Sie in die Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
          personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO bzw. Art. 9
          Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien nach Art. 9 Abs. 1 DSGVO
          verarbeitet werden. Im Falle einer ausdrücklichen Einwilligung in die Übertragung
          personenbezogener Daten in Drittstaaten erfolgt die Datenverarbeitung außerdem auf
          Grundlage von Art. 49 Abs. 1 lit. a DSGVO. Sofern Sie in die Speicherung von
          Cookies oder in den Zugriff auf Informationen in Ihr Endgerät (z. B.
          Device-Fingerprinting) eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich
          auf Grundlage von § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
          Sind Ihre Daten zur Vertragserfüllung oder zur Durchführung vorvertraglicher
          Maßnahmen erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6 Abs. 1
          lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern diese zur Erfüllung
          einer rechtlichen Verpflichtung erforderlich sind auf Grundlage von Art. 6 Abs. 1
          lit. c DSGVO. Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
          Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die jeweils im
          Einzelfall einschlägigen Rechtsgrundlagen wird in den folgenden Absätzen dieser
          Datenschutzerklärung informiert.
        </p>

        <h2>
          Hinweis zur Datenweitergabe in datenschutzrechtlich nicht sichere Drittstaaten
          sowie die Weitergabe an US-Unternehmen, die nicht DPF-zertifiziert sind
        </h2>
        <p>
          Wir verwenden unter anderem Tools von Unternehmen mit Sitz in
          datenschutzrechtlich nicht sicheren Drittstaaten sowie US-Tools, deren Anbieter
          nicht nach dem EU-US-Data Privacy Framework (DPF) zertifiziert sind. Wenn diese
          Tools aktiv sind, können Ihre personenbezogene Daten in diese Staaten übertragen
          und dort verarbeitet werden. Wir weisen darauf hin, dass in datenschutzrechtlich
          unsicheren Drittstaaten kein mit der EU vergleichbares Datenschutzniveau
          garantiert werden kann. Wir weisen darauf hin, dass die USA als sicherer
          Drittstaat grundsätzlich ein mit der EU vergleichbares Datenschutzniveau
          aufweisen. Eine Datenübertragung in die USA ist danach zulässig, wenn der Empfänger
          eine Zertifizierung unter dem „EU-US Data Privacy Framework“ (DPF) besitzt oder
          über geeignete zusätzliche Garantien verfügt. Informationen zu Übermittlungen an
          Drittstaaten einschließlich der Datenempfänger finden Sie in dieser
          Datenschutzerklärung.
        </p>
        <p>
          We would like to point out that the US, as a secure third-party country,
          generally has a level of data protection comparable to that of the EU. Data
          transfer to the US is therefore permitted if the recipient is certified under the
          “EU-US Data Privacy Framework” (DPF) or has appropriate additional assurances.
          Information on transfers to third-party countries, including the data recipients,
          can be found in this Privacy Policy.
        </p>

        <h2>Empfänger von personenbezogenen Daten</h2>
        <p>
          Im Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen externen
          Stellen zusammen. Dabei ist teilweise auch eine Übermittlung von personenbezogenen
          Daten an diese externen Stellen erforderlich. Wir geben personenbezogene Daten nur
          dann an externe Stellen weiter, wenn dies im Rahmen einer Vertragserfüllung
          erforderlich ist, wenn wir gesetzlich hierzu verpflichtet sind (z. B. Weitergabe
          von Daten an Steuerbehörden), wenn wir ein berechtigtes Interesse nach Art. 6 Abs.
          1 lit. f DSGVO an der Weitergabe haben oder wenn eine sonstige Rechtsgrundlage die
          Datenweitergabe erlaubt. Beim Einsatz von Auftragsverarbeitern geben wir
          personenbezogene Daten unserer Kunden nur auf Grundlage eines gültigen Vertrags
          über Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung wird ein
          Vertrag über gemeinsame Verarbeitung geschlossen.
        </p>

        <h2>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h2>
        <p>
          Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung
          möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die
          Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom
          Widerruf unberührt.
        </p>

        <h2>
          Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen
          Direktwerbung (Art. 21 DSGVO)
        </h2>
        <p>
          Wenn die Datenverarbeitung auf Grundlage von Art. 6 Abs. 1 lit. e oder f DSGVO
          erfolgt, haben Sie jederzeit das Recht, aus Gründen, die sich aus Ihrer besonderen
          Situation ergeben, gegen die Verarbeitung Ihrer personenbezogenen Daten
          Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes
          Profiling. Die jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht,
          entnehmen Sie dieser Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden
          wir Ihre betroffenen personenbezogenen Daten nicht mehr verarbeiten, es sei denn,
          wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die
          Ihre Interessen, Rechte und Freiheiten überwiegen oder die Verarbeitung dient der
          Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen (Widerspruch Art.
          21 Abs. 1 DSGVO).
        </p>
        <p>
          Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, so
          haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie
          betreffender personenbezogener Daten zum Zwecke derartiger Werbung einzulegen;
          dies gilt auch für das Profiling soweit es mit solcher Direktwerbung in Verbindung
          steht. Wenn Sie widersprechen, werden Ihre personenbezogenen Daten anschließend
          nicht mehr zum Zwecke der Direktwerbung verwendet (Widerspruch nach Art. 21 Abs. 2
          DSGVO).
        </p>

        <h2>Beschwerderecht bei der zuständigen Aufsichtsbehörde</h2>
        <p>
          Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht
          bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen
          Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das
          Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder
          gerichtlicher Rechtsbehelfe.
        </p>

        <h2>Recht auf Datenübertragbarkeit</h2>
        <p>
          Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in
          Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten
          in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die
          direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt
          dies nur, soweit es technisch machbar ist.
        </p>

        <h2>Auskunft, Berichtigung und Löschung</h2>
        <p>
          Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht
          auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren
          Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf
          Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
          personenbezogene Daten können Sie sich jederzeit an uns wenden.
        </p>

        <h2>Recht auf Einschränkung der Verarbeitung</h2>
        <p>
          Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen
          Daten zu verlangen. Hierzu können Sie sich jederzeit an uns wenden. Das Recht auf
          Einschränkung der Verarbeitung besteht in folgenden Fällen:
        </p>
        <ul>
          <li>
            Wenn Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen Daten
            bestreiten, benötigen wir in der Regel Zeit, um dies zu überprüfen. Für die
            Dauer der Prüfung haben Sie das Recht, die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen.
          </li>
          <li>
            Wenn die Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah/geschieht, können Sie statt der Löschung die Einschränkung der
            Datenverarbeitung verlangen.
          </li>
          <li>
            Wenn wir Ihre personenbezogenen Daten nicht mehr benötigen, Sie sie jedoch zur
            Ausübung, Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen,
            haben Sie das Recht, statt der Löschung die Einschränkung der Verarbeitung Ihrer
            personenbezogenen Daten zu verlangen.
          </li>
          <li>
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt haben, muss eine
            Abwägung zwischen Ihren und unseren Interessen vorgenommen werden. Solange noch
            nicht feststeht, wessen Interessen überwiegen, haben Sie das Recht, die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </li>
        </ul>
        <p>
          Wenn Sie die Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben,
          dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung
          oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum
          Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus
          Gründen eines wichtigen öffentlichen Interesses der Europäischen Union oder eines
          Mitgliedstaats verarbeitet werden.
        </p>

        <h2>SSL- bzw. TLS-Verschlüsselung</h2>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
          vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns
          als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
          Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://“ auf
          „https://“ wechselt und an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL-
          bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
          übermitteln, nicht von Dritten mitgelesen werden.
        </p>

        <h2>Widerspruch gegen Werbe-E-Mails</h2>
        <p>
          Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten zur
          Übersendung von nicht ausdrücklich angeforderter Werbung und
          Informationsmaterialien wird hiermit widersprochen. Die Betreiber der Seiten
          behalten sich ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung
          von Werbeinformationen, etwa durch Spam-E-Mails, vor.
        </p>
      </div>

      {/* 4. Datenerfassung auf dieser Website */}
      <div className="datenschutz-section">
        <h1>4. Datenerfassung auf dieser Website</h1>

        <h2>Cookies</h2>
        <p>
          Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine
          Datenpakete und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder
          vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft
          (permanente Cookies) auf Ihrem Endgerät gespeichert. Session-Cookies werden nach
          Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem
          Endgerät gespeichert, bis Sie diese selbst löschen oder eine automatische Löschung
          durch Ihren Webbrowser erfolgt.
        </p>
        <p>
          Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen
          (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung
          bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten (z. B.
          Cookies zur Abwicklung von Zahlungsdienstleistungen).
        </p>
        <p>
          Cookies haben verschiedene Funktionen. Zahlreiche Cookies sind technisch
          notwendig, da bestimmte Webseitenfunktionen ohne diese nicht funktionieren würden
          (z.B. die Warenkorbfunktion oder die Anzeige von Videos). Andere Cookies können
          zur Auswertung des Nutzerverhaltens oder zu Werbezwecken verwendet werden.
        </p>
        <p>
          Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs, zur
          Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z. B. für die
          Warenkorbfunktion) oder zur Optimierung der Website (z. B. Cookies zur Messung des
          Webpublikums) erforderlich sind (notwendige Cookies), werden auf Grundlage von
          Art. 6 Abs. 1 lit. f DSGVO gespeichert, sofern keine andere Rechtsgrundlage
          angegeben wird. Der Websitebetreiber hat ein berechtigtes Interesse an der
          Speicherung von notwendigen Cookies zur technisch fehlerfreien und optimierten
          Bereitstellung seiner Dienste. Sofern eine Einwilligung zur Speicherung von
          Cookies und vergleichbaren Wiedererkennungstechnologien abgefragt wurde, erfolgt
          die Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art. 6 Abs. 1
          lit. a DSGVO und § 25 Abs. 1 TDDDG); die Einwilligung ist jederzeit widerrufbar.
        </p>
        <p>
          Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies
          informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies
          für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der
          Cookies beim Schließen des Browsers aktivieren. Bei der Deaktivierung von Cookies
          kann die Funktionalität dieser Website eingeschränkt sein. Welche Cookies und
          Dienste auf dieser Website eingesetzt werden, können Sie dieser
          Datenschutzerklärung entnehmen.
        </p>

        <h2>Kontaktformular</h2>
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus
          dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung dieser
          Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage
          mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung
          vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die
          Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der
          an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
          Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde; die
          Einwilligung ist jederzeit widerrufbar. Die von Ihnen im Kontaktformular
          eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre
          Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung
          entfällt (z. B. nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende
          gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben
          unberührt.
        </p>

        <h2>Kommunikation via WhatsApp</h2>
        <p>
          Für die Kommunikation mit unseren Kunden und sonstigen Dritten nutzen wir unter
          anderem den Instant-Messaging-Dienst WhatsApp. Anbieter ist die WhatsApp Ireland
          Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
        </p>
        <p>
          Die Kommunikation erfolgt über eine Ende-zu-Ende-Verschlüsselung (Peer-to-Peer),
          die verhindert, dass WhatsApp oder sonstige Dritte Zugriff auf die
          Kommunikationsinhalte erlangen können. WhatsApp erhält jedoch Zugriff auf
          Metadaten, die im Zuge des Kommunikationsvorgangs entstehen (z. B. Absender,
          Empfänger und Zeitpunkt). Wir weisen ferner darauf hin, dass WhatsApp nach eigener
          Aussage personenbezogene Daten seiner Nutzer mit seiner in den USA ansässigen
          Konzernmutter Meta teilt. Weitere Details zur Datenverarbeitung finden Sie in der
          Datenschutzrichtlinie von WhatsApp unter:{' '}
          <a target="_blank" rel="noopener noreferrer" href="https://www.whatsapp.com/legal/privacy-policy">
            https://www.whatsapp.com/legal/privacy-policy
          </a>
        </p>
        <p>
          Der Einsatz von WhatsApp erfolgt auf Grundlage unseres berechtigten Interesses an
          einer möglichst schnellen und effektiven Kommunikation mit Kunden, Interessenten
          und sonstigen Geschäfts- und Vertragspartnern (Art. 6 Abs. 1 lit. f DSGVO). Sofern
          eine entsprechende Einwilligung abgefragt wurde, erfolgt die Datenverarbeitung
          ausschließlich auf Grundlage der Einwilligung; diese ist jederzeit mit Wirkung für
          die Zukunft widerrufbar.
        </p>
        <p>
          Die zwischen Ihnen und uns auf WhatsApp ausgetauschten Kommunikationsinhalte
          verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
          Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B.
          nach abgeschlossener Bearbeitung Ihrer Anfrage). Zwingende gesetzliche
          Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt. Das
          Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy
          Framework“ (DPF). Der DPF ist ein Übereinkommen zwischen der Europäischen Union
          und den USA, der die Einhaltung europäischer Datenschutzstandards bei
          Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem DPF
          zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards
          einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter
          folgendem Link:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.dataprivacyframework.gov/s/participant search/participantdetail?contact=true&id=a2zt00000011sfnAAA&status=Active"
          >
            https://www.dataprivacyframework.gov/s/participant search/participantdetail?contact=true&id=a2zt00000011sfnAAA&status=Active
          </a>
        </p>
        <p>
          Wir nutzen WhatsApp in der Variante „WhatsApp Business“. Die Datenübertragung in
          die USA wird auf die Standardvertragsklauseln der EU-Kommission gestützt. Details
          finden Sie hier:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.whatsapp.com/legal/business-data-transfer-addendum?lang=en"
          >
            https://www.whatsapp.com/legal/business-data-transfer-addendum?lang=en
          </a>
        </p>
      </div>

      {/* 5. Analyse-Tools und Werbung */}
      <div className="datenschutz-section">
        <h1>5. Analyse-Tools und Werbung</h1>

        <h2>Google Analytics</h2>
        <p>
          Diese Website nutzt Funktionen des Webanalysedienstes Google Analytics. Anbieter
          ist die Google Ireland Limited („Google“), Gordon House, Barrow Street, Dublin 4,
          Irland. Google Analytics ermöglicht es dem Websitebetreiber, das Verhalten der
          Websitebesucher zu analysieren. Hierbei erhält der Websitebetreiber verschiedene
          Nutzungsdaten, wie z. B. Seitenaufrufe, Verweildauer, verwendete Betriebssysteme
          und Herkunft des Nutzers. Diese Daten werden in einer User-ID zusammengefasst und
          dem jeweiligen Endgerät des Websitebesuchers zugeordnet. Des Weiteren können wir
          mit Google Analytics u. a. Ihre Maus- und Scrollbewegungen und Klicks aufzeichnen.
          Ferner verwendet Google Analytics verschiedene Modellierungsansätze, um die
          erfassten Datensätze zu ergänzen und setzt Machine-Learning-Technologien bei der
          Datenanalyse ein. Google Analytics verwendet Technologien, die die Wiedererkennung
          des Nutzers zum Zwecke der Analyse des Nutzerverhaltens ermöglichen (z. B. Cookies
          oder Device-Fingerprinting). Die von Google erfassten Informationen über die
          Benutzung dieser Website werden in der Regel an einen Server von Google in den USA
          übertragen und dort gespeichert.
        </p>
        <p>
          Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
          Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
          widerrufbar. Die Datenübertragung in die USA wird auf die
          Standardvertragsklauseln der EU-Kommission gestützt. Details finden Sie hier:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://privacy.google.com/businesses/controllerterms/mccs/"
          >
            https://privacy.google.com/businesses/controllerterms/mccs/
          </a>
          . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy
          Framework“ (DPF). Der DPF ist ein Übereinkommen zwischen der Europäischen Union
          und den USA, der die Einhaltung europäischer Datenschutzstandards bei
          Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem DPF
          zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards
          einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter
          folgendem Link:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.dataprivacyframework.gov/participant/5780"
          >
            https://www.dataprivacyframework.gov/participant/5780
          </a>
          .
        </p>

        <h2>IP Anonymisierung</h2>
        <p>
          Die Google Analytics IP-Anonymisierung ist aktiviert. Dadurch wird Ihre IP-Adresse
          von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen
          Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum vor der
          Übermittlung in die USA gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse
          an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des
          Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre
          Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten
          zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung
          verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im
          Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht
          mit anderen Daten von Google zusammengeführt.
        </p>

        <h2>Browser plug-in</h2>
        <p>
          Sie können die Erfassung und Verarbeitung Ihrer Daten durch Google verhindern,
          indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und
          installieren:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tools.google.com/dlpage/gaoptout?hl=en"
          >
            https://tools.google.com/dlpage/gaoptout?hl=en
          </a>
          . Mehr Informationen zum Umgang mit Nutzerdaten bei Google Analytics finden Sie in
          der Datenschutzerklärung von Google:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://support.google.com/analytics/answer/6004245?hl=en"
          >
            https://support.google.com/analytics/answer/6004245?hl=en
          </a>
          .
        </p>

        <h2>Demografische Merkmale bei Google Analytics</h2>
        <p>
          Diese Website nutzt die Funktion „demografische Merkmale“ von Google Analytics, um
          den Websitebesuchern passende Werbeanzeigen innerhalb des Google-Werbenetzwerks
          anzeigen zu können. Dadurch können Berichte erstellt werden, die Aussagen zu Alter,
          Geschlecht und Interessen der Seitenbesucher enthalten. Diese Daten stammen aus
          interessenbezogener Werbung von Google sowie aus Besucherdaten von Drittanbietern.
          Diese Daten können keiner bestimmten Person zugeordnet werden. Sie können diese
          Funktion jederzeit über die Anzeigeneinstellungen in Ihrem Google-Konto
          deaktivieren oder die Erfassung Ihrer Daten durch Google Analytics wie im Punkt
          „Widerspruch gegen Datenerfassung“ dargestellt generell untersagen.
        </p>

        <h2>Google Ads</h2>
        <p>
          Der Websitebetreiber verwendet Google Ads. Google Ads ist ein Online-Werbeprogramm
          der Google Ireland Limited („Google“), Gordon House, Barrow Street, Dublin 4,
          Irland.
        </p>
        <p>
          Google Ads ermöglicht es uns Werbeanzeigen in der Google-Suchmaschine oder auf
          Drittwebseiten auszuspielen, wenn der Nutzer bestimmte Suchbegriffe bei Google
          eingibt (Keyword-Targeting). Ferner können zielgerichtete Werbeanzeigen anhand der
          bei Google vorhandenen Nutzerdaten (z. B. Standortdaten und Interessen)
          ausgespielt werden (Zielgruppen-Targeting). Wir als Websitebetreiber können diese
          Daten quantitativ auswerten, indem wir beispielsweise analysieren, welche
          Suchbegriffe zur Ausspielung unserer Werbeanzeigen geführt haben und wie viele
          Anzeigen zu entsprechenden Klicks geführt haben.
        </p>
        <p>
          Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6
          Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Die Einwilligung ist jederzeit
          widerrufbar. Die Datenübertragung in die USA wird auf die Standardvertragsklauseln
          der EU-Kommission gestützt. Details finden Sie hier:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://policies.google.com/privacy/frameworks"
          >
            https://policies.google.com/privacy/frameworks
          </a>{' '}
          und{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://business.safety.google/controllerterms/"
          >
            https://business.safety.google/controllerterms/
          </a>
          .
        </p>
        <p>
          Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US Data Privacy
          Framework“ (DPF). Der DPF ist ein Übereinkommen zwischen der Europäischen Union
          und den USA, der die Einhaltung europäischer Datenschutzstandards bei
          Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem DPF
          zertifizierte Unternehmen verpflichtet sich, diese Datenschutzstandards
          einzuhalten. Weitere Informationen hierzu erhalten Sie vom Anbieter unter folgendem
          Link:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.dataprivacyframework.gov/participant/5780"
          >
            https://www.dataprivacyframework.gov/participant/5780
          </a>
          .
        </p>
      </div>

      {/* 6. eCommerce und Zahlungsanbieter */}
      <div className="datenschutz-section">
        <h1>6. eCommerce und Zahlungsanbieter</h1>
        <h2>Datenübermittlung bei Vertragsschluss für Dienstleistungen und digitale Inhalte</h2>
        <p>
          Wir übermitteln personenbezogene Daten an Dritte nur dann, wenn dies im Rahmen der
          Vertragsabwicklung notwendig ist, etwa an das mit der Zahlungsabwicklung
          beauftragte Kreditinstitut. Eine weitergehende Übermittlung der Daten erfolgt
          nicht bzw. nur dann, wenn Sie der Übermittlung ausdrücklich zugestimmt haben. Eine
          Weitergabe Ihrer Daten an Dritte ohne ausdrückliche Einwilligung, etwa zu Zwecken
          der Werbung, erfolgt nicht. Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1
          lit. b DSGVO, der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder
          vorvertraglicher Maßnahmen gestattet.
        </p>

        <h2>Zahlungsdienste</h2>
        <p>
          Wir binden Zahlungsdienste von Drittunternehmen auf unserer Website ein. Wenn Sie
          einen Kauf bei uns tätigen, werden Ihre Zahlungsdaten (z. B. Name, Zahlungssumme,
          Kontoverbindung, Kreditkartennummer) vom Zahlungsdienstleister zum Zwecke der
          Zahlungsabwicklung verarbeitet. Für diese Transaktionen gelten die jeweiligen
          Vertrags- und Datenschutzbestimmungen der jeweiligen Anbieter. Der Einsatz der
          Zahlungsdienstleister erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO
          (Vertragsabwicklung) sowie im Interesse eines möglichst reibungslosen,
          komfortablen und sicheren Zahlungsvorgangs (Art. 6 Abs. 1 lit. f DSGVO). Soweit
          für bestimmte Handlungen Ihre Einwilligung abgefragt wird, ist Art. 6 Abs. 1 lit.
          a DSGVO Rechtsgrundlage der Datenverarbeitung; Einwilligungen sind jederzeit für
          die Zukunft widerrufbar.
        </p>
        <p>
          Folgende Zahlungsdienste / Zahlungsdienstleister setzen wir im Rahmen dieser
          Website ein: <b>Stripe</b>
        </p>
        <p>
          Anbieter für Kunden innerhalb der EU ist die Stripe Payments Europe, Ltd.,1 Grand
          Canal Street Lower, Grand Canal Dock, Dublin, Irland (im Folgenden „Stripe“). Die
          Datenübertragung in die USA wird auf die Standardvertragsklauseln der
          EU-Kommission gestützt. Details finden Sie hier:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://stripe.com/de/privacy"
          >
            https://stripe.com/de/privacy
          </a>{' '}
          und{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://stripe.com/de/guides/general-data-protection-regulation"
          >
            https://stripe.com/de/guides/general-data-protection-regulation
          </a>
          . Details can be found in Stripe’s Privacy Policy at the following link:{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://stripe.com/de/privacy"
          >
            https://stripe.com/de/privacy
          </a>
          .
        </p>
      </div>

      {/* 7. Eigene Dienste */}
      <div className="datenschutz-section">
        <h1>7. Eigene Dienste</h1>
        <h2>OneDrive</h2>
        <p>
          Wir haben OneDrive auf dieser Website eingebunden. Anbieter ist die Microsoft
          Ireland Operations Limited, One Microsoft Place, South County Business Park,
          Leopardstown, Dublin 18, Irland (im folgenden „OneDrive“). OneDrive ermöglicht es
          uns, einen Uploadbereich auf unserer Website einzubinden, in dem Sie Inhalte
          hochladen können. Wenn Sie Inhalte hochladen, werden diese auf den Servern von
          OneDrive gespeichert. Wenn Sie unsere Website betreten, wird außerdem eine
          Verbindung zu OneDrive aufgebaut, sodass OneDrive feststellen kann, dass Sie unsere
          Website besucht haben. Die Verwendung von OneDrive erfolgt auf Grundlage von Art.
          6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an
          einem zuverlässigen Uploadbereich auf seiner Website. Sofern eine entsprechende
          Einwilligung abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
          Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die Einwilligung ist jederzeit
          widerrufbar.
        </p>
      </div>
    </div>
  );
}

export default Datenschutz;
